import screenbanner from "./images/banner/1.jpg";
import mobilebanner from "./images/banner/2.jpg"
import location1 from "./images/blog/News/4.jpg";
import location2 from "./images/blog/News/1.jpg";
import location3 from "./images/blog/News/6.jpg"
import newsShape1 from "./images/shapes/news-one-shape-1.png";
import overviewImage from "./images/blog/1.jpg";


export const Bannerdata = {
  mobilebanner: mobilebanner,
  screenbanner: screenbanner,
};
export const OverviewData = {
  overviewImage: overviewImage,
  buttonLabel: "Enquire Now",
  tagline: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
  description: [
 
      `TARC Ltd has reported impressive pre-sales of Rs 1,165 crore for Q3 FY25, bringing its total
pre-sales for the first nine months of FY2025 to Rs 2,487 crore—a nearly six-fold increase
compared to the same period last year. In addition, customer collections for Q3 FY25 reached
Rs 181 crore, contributing to a total of Rs 371 crore in collections for the first three quarters of
the fiscal year.
   `,
   `The company attributes its strong performance to rising demand in the luxury real estate
segment and the effective execution of its business strategies. Notably, TARC’s flagship project,
TARC Ishva, has achieved pre-sales of approximately Rs 1,500 crore to date.
Further enhancing its growth prospects, TARC has recently acquired a new land parcel in
Gurugram, boosting its portfolio and increasing its potential Gross Development Value (GDV).
Amar Sarin, Managing Director and CEO of TARC Ltd, expressed pride in the company’s ability
to consistently achieve four-figure pre-sales numbers. “This clearly reflects the success of our
focus on world-class luxury developments and timely delivery. Every challenge strengthens our
resilience and prepares us for even greater success,” Sarin stated.`
 ,
 `Sarin also highlighted the impact of upcoming infrastructure developments, including four
strategic highway projects in Delhi announced by Union Minister for Road Transport and
Highways, Nitin Gadkari. These projects are expected to significantly enhance the city&#39;s
connectivity, unlocking new opportunities for TARC’s land holdings in Delhi and driving future
growth.
The luxury real estate markets in Delhi and Gurugram are well-positioned for continued
expansion, supported by strong demand, key infrastructure improvements, and the region&#39;s
appeal to high-net-worth individuals. As India’s economy grows, the luxury sector is set to
benefit from an increasingly affluent population, with rising demand for premium residences in
these thriving urban centers.`,
  ],
  amenities: ["High Demand", "Future-Ready Smart Homes"],
  buttonmessage: "More details",
};

// Latest Update
export const LatestUpdate = {
  tagline: `Related Blogs`,
  shape1: newsShape1,
  data: [
     {
       id: 1,
       image: location1,
       alt: "Google",
       date: "01 Jan",
       tag: "Google Leases 5.5 Lakh Sq Ft Office Space in Gurugram, with Plans for Future Expansion",
       title: `Google has secured a significant 550,000 sq ft of office space in Gurugram. `,
       link: "/news-070125",
       review: 2,
     },
     {
       id: 2,
       image: location2,
       alt: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
       date: "06 Jan",
       tag: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
       title: `TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25 TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25`,
       link: "/news-080125",
       review: 3,
     },
     {
       id: 3,
       image: location3,
       alt: "Prestige Group Invests Rs 462",
       date: "30 Oct",
       tag: "Prestige Group Invests Rs 462 Crore to Acquire 17.45 Acres of Land in Bengaluru",
       title:
       `Prestige Group, a leading name in India’s real estate sector, has acquired a prime 17.45-acre
 land parcel in Bengaluru`,
       link: "/news-090125",
       review: 5,
     },
   ],
};
